import Track from 'core/logger/track';

class MiscTrack {
  signupBtnClicked = (btnPosition: string) => {
    Track.getInstance().signupLinkClicked(btnPosition);
  };

  homePageBtnClick = (btnPosition: string) => {
    Track.getInstance().ampEvent('homePageLinkClicked', { position: btnPosition });
  };

  // befow function is also written in auth tracking
  extensionLinkClicked = (extensionName: 'word' | 'chrome' | 'docs', position: string) => {
    const eventName = 'clickedExtensionLink';
    const data = {
      extensionName,
      position,
    };
    Track.getInstance().storeActionEvent(eventName, data);
    Track.getInstance().ampEvent(eventName, data);
  };
}

const miscTrack = new MiscTrack();
export default miscTrack;
